// extracted by mini-css-extract-plugin
export var labelWrapper = "_fo-0";